<div class="add-boleto-dialog card">
    <div class="card-header">
        <h2>Adicionar Boleto</h2>
        <p>Busque por Carnê/Cód. Aluno/Nome do Aluno para selecionar o boleto.</p>
    </div>

    <div class="card-body">
        <div class="search-row">
            <mat-form-field appearance="outline" class="flex-grow-1">
                <mat-label>Carnê/Cód. Aluno/Nome do Aluno</mat-label>
                <input matInput [(ngModel)]="searchTerm" (keyup.enter)="onSearch()" />
            </mat-form-field>
            <button class="btn btn-primary btn-search" (click)="onSearch()" [disabled]="!searchTerm || loading">
                <i class="fas fa-search"></i> Buscar
            </button>
        </div>

        <mat-spinner *ngIf="loading" diameter="28" class="mx-auto"></mat-spinner>

        <div class="table-responsive" *ngIf="boletos.length && !loading">
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th class="text-muted"></th>
                        <th class="text-muted">Carnê</th>
                        <th class="text-muted">Cód. Aluno</th>
                        <th class="text-muted">Vencimento</th>
                        <th class="text-muted">Status</th>
                        <th class="text-muted text-right">Nominal</th>
                        <th class="text-muted text-right">Pago</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let b of boletos" (click)="toggleSelection(b)"
                        [class.selected]="isSelected(b)">
                        <td><mat-checkbox [checked]="isSelected(b)" (click)="$event.stopPropagation()" (change)="toggleSelection(b)"></mat-checkbox></td>
                        <td>{{ b.numeroCarne }}</td>
                        <td>{{ b.codigoAluno }}</td>
                        <td>{{ b.dataVencimento | date:'dd/MM/yyyy' }}</td>
                        <td>{{ b.statusCobrancaDescricao }}</td>
                        <td class="text-right">{{ b.valorNominal | currency:'BRL':'':'1.2-2' }}</td>
                        <td class="text-right">{{ b.valorPago | currency:'BRL':'':'1.2-2' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <p *ngIf="searched && !boletos.length && !loading" class="text-muted text-center mt-3">
            Nenhum boleto encontrado.
        </p>
    </div>

    <div class="card-footer">
        <button class="btn btn-outline-secondary" (click)="onCancel()">Cancelar</button>
        <button class="btn btn-primary" [disabled]="!selectedBoletos.length" (click)="onConfirm()">Adicionar</button>
    </div>
</div>
